module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8004.e3a77176.png";